export const SITE = {
  baseUrl: 'https://www.bidcontext.ai',
  name: 'BidContext',
  defaultOgImage: 'https://www.bidcontext.ai/images/og-card.png',
  ogImageAlt: 'BidContext - AI workspace for bid writing and tender responses',
  locale: 'en_AU',
} as const
